import { useMemo } from 'react';
import { dispatcher } from 'dispatcher';
import { useIsPageInPopupUrl } from 'js/components/system/Page/hooks';

export const usePagePublicAPI = () => {
    const isPageInPopupUrl = useIsPageInPopupUrl();

    return useMemo(() => ({
        /**
         * Triggers pageInfo request.
         * @memberOf Playtech.API.page
         * @function
         * @example
         * Playtech.API.page.requestPageUpdate();
         */
        requestPageUpdate: () => {
            dispatcher.dispatch('page:update:request');
        },
        /**
         * Triggers pageInfo request.
         * @memberOf Playtech.API.page
         * @function
         * @example
         * Playtech.API.page.requestPageInPopupUpdate();
         */
        requestPageInPopupUpdate: () => {
            dispatcher.dispatch('page-in-popup:update:request');
        },
        /**
         * Get whether page is in popup or non-custom quickDepositPage or is static page i.e. /online-game/ or is bonus page.
         * @memberOf Playtech.API.page
         * @function
         * @returns {Boolean}
         * @example
         * // false
         * Playtech.API.page.isPageInPopupUrl();
         */
        isPageInPopupUrl
    }), [
        isPageInPopupUrl
    ]);
};
